var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start",attrs:{"pa-0":"","fluid":"","fill-height":""}},[_c('FullHeader'),(_vm.$store.projectsStore.state.selectedProject && _vm.$store.projectsStore.state.selectedProject != 1)?_c('ProjectDetail'):_c('NoSelectedProject')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }